document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.archive-carousel-container').forEach(carousel => {
        const track = carousel.querySelector('.archive-carousel-track');
        const items = Array.from(track.children);
        const prevBtn = carousel.querySelector('.archive-carousel-prev');
        const nextBtn = carousel.querySelector('.archive-carousel-next');

        let currentIndex = 0;

        const getItemsToShow = () => {
            const screenWidth = window.innerWidth;

            if (screenWidth <= 413) {
                return 2;
            } else if (screenWidth <= 550) {
                return 3;
            } else if (screenWidth <= 1210) {
                return 4;
            }
        };

        const updateCarousel = () => {
            const itemsToShow = getItemsToShow();
            const gap = parseInt(getComputedStyle(track).gap) || 0;
            const itemWidth = items[0].offsetWidth + gap;

            track.style.transform = `translateX(-${currentIndex * itemWidth}px)`;

            prevBtn.disabled = currentIndex === 0;
            nextBtn.disabled = currentIndex >= items.length - itemsToShow;
        };

        const handleNext = () => {
            console.log('coucou')
            const itemsToShow = getItemsToShow();
            if (currentIndex < items.length - itemsToShow) {
                currentIndex++;
                updateCarousel();
            }
        };

        const handlePrev = () => {
            if (currentIndex > 0) {
                currentIndex--;
                updateCarousel();
            }
        };

        nextBtn.addEventListener('click', handleNext);
        prevBtn.addEventListener('click', handlePrev);

        window.addEventListener('resize', updateCarousel);

        updateCarousel();
    });
});